export const GET_OAUTHS="GET_OAUTHS"
export const CREATE_OAUTH="CREATE_OAUTH"
export const DELETE_OAUTH="DELETE_OAUTH"
export const EDIT_OAUTH="EDIT_OAUTH"